import { render } from "./LauncherSettings.vue?vue&type=template&id=6129047c"
import script from "./LauncherSettings.vue?vue&type=script&lang=js"
export * from "./LauncherSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__